import bookingStore from './store.js';

/**
 * Booking AJAX functions
 */

/**
 * Get user availability by user ID
 * @param {number} userId - User ID to get availability for
 * @returns {Promise<Object>} Availability data by day
 */
export async function loadUserAvailability(userId) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_user_availability');
	formData.append('user_id', userId);
	formData.append('nonce', window.wpcore?.nonce || '');
	if (bookingStore.getCoachAvailability()) {
		return;
	}

	const response = await fetch(window.wpcore?.ajaxUrl || '/wp-admin/admin-ajax.php', {
		method: 'POST',
		body: formData,
	});

	const data = await response.json();
	bookingStore.setCoachAvailability(data.data.availability);
}

/**
 * Get coach bookings by coach ID and optional date range
 * @param {number} coachId - Coach user ID
 * @param {string|null} startDate - Optional start date filter (Y-m-d format)
 * @param {string|null} endDate - Optional end date filter (Y-m-d format)
 * @returns {Promise<Array>} Array of booking objects
 */
export async function getCoachBookings(coachId, startDate = null, endDate = null) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_coach_bookings');
	formData.append('coach_id', coachId);
	formData.append('nonce', window.wpcore?.nonce || '');

	if (startDate) {
		formData.append('start_date', startDate);
	}
	if (endDate) {
		formData.append('end_date', endDate);
	}

	const response = await fetch(window.wpcore?.ajaxUrl || '/wp-admin/admin-ajax.php', {
		method: 'POST',
		body: formData,
	});

	const data = await response.json();
	if (!data.success) {
		wpcore.alert('error', data.data?.message || wpcore.direct_t({ en: 'Failed to get coach bookings', fr: 'Échec de la récupération des réservations du coach' }));
		return null;
	}
	bookingStore.setBookings(data.data.bookings);
	return data.data.bookings;
}


export async function getRemainingSession() {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_sessions_remaining');
	formData.append('nonce', wpcore.nonce);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const result = await response.json();
	if (!result.success) {
		wpcore.alert('error', result.data?.message || wpcore.direct_t({ en: 'Failed to get remaining sessions', fr: 'Échec de la récupération des sessions restantes' }));
		return null;
	}
	return result.data;
}

export async function createSession(date, time, duration) {
	const formData = new FormData();
	formData.append('action', 'wpcore_create_session');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_date', date);
	formData.append('session_time', time);
	formData.append('duration_minutes', duration);

	// Call API
	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const result = await response.json();
	if (!result.success) {
		wpcore.alert('error', result.data?.message || wpcore.direct_t({ en: 'Failed to create session', fr: 'Échec de la création de la session' }));
		return null;
	}
	return result.data;
}

export async function rescheduleSession(sessionId, date, time, duration) {
	const formData = new FormData();
	formData.append('action', 'wpcore_reschedule_session');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_id', sessionId);
	formData.append('session_date', date);
	formData.append('session_time', time);
	formData.append('duration_minutes', duration);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const result = await response.json();
	if (!result.success) {
		wpcore.alert('error', result.data?.message || wpcore.direct_t({ en: 'Failed to reschedule session', fr: 'Échec du report de la session' }));
		return null;
	}
	return result.data;
}
